module.exports = __webpack_public_path__ + "static/img/home_icon4.bf1768a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/home_icon4.jpg
// module id = 578
// module chunks = 4 5